import { Injectable, inject } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { MainService } from "core/main.service";

@Injectable({ providedIn: "root" })
export class HomeGuard implements CanActivate {
	private router = inject(Router);
	private mainService = inject(MainService);

	canActivate(): Promise<boolean> {
		// eslint-disable-next-line @typescript-eslint/require-await -- TODO: Remove this comment and fix warnings!
		return this.mainService.getApplication("_vv").then(async (application) => {
			this.router.navigate(["workspace", application.homeWorkspace.id, "_vv", "home"]);
			return false;
		});
	}
}
